// @flow

import React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { sortPackageCompareTable } from './helpers';
import {
  Container,
  ShortcodeWrapper,
  Table,
  GroupTitle,
  PackageTitle,
  Row,
  Item,
  Check,
  IconWrapper,
} from './atoms';
import { getEntries } from '../../helpers';
import { getPackageContentsTable, getShortcodes, getOriginalNames } from '../../store/pdb/selectors';
import type { PackageShortcode, PackageOriginalName, PackageContentTable } from '../../types/pdb';
import type { Theme } from '../../types';

type StateProps = {|
  shortcodes: PackageShortcode[],
  originalnames: PackageOriginalName[],
  packageCompareTable: PackageContentTable,
|};

type Props = StateProps;

const Icon = styled<any, Theme>('i')`
  font-size: .65rem;
  &:before {
    vertical-align: bottom;
  }
`;

const PackageCompare = ({
  packageCompareTable,
  shortcodes,
  originalnames,
}: Props) => (
  <Container>
    <ShortcodeWrapper>
      {shortcodes.map((code, index) => (
        <div key={code.id}>
          <strong>
            {code.shortcode}
&nbsp;
          </strong>
          <span>
            {originalnames[index].originalname}
&nbsp;
          </span>
        </div>
      ))}
    </ShortcodeWrapper>
    {sortPackageCompareTable(packageCompareTable).map(([groupTitle, list], index) => (
    // eslint-disable-next-line react/no-array-index-key
      <Table key={index}>
        <thead>
          <tr>
            <GroupTitle>{groupTitle}</GroupTitle>
            {shortcodes.map(({ id, shortcode }) => (
              <PackageTitle key={id.toString()}>
                {shortcode}
              </PackageTitle>
            ))}
          </tr>
        </thead>
        <tbody>
          {getEntries(list).map(([item, inPackage]) => (
            <Row key={item}>
              <Item>{item}</Item>
              {shortcodes.map(({ id }) => (
                <Check key={id.toString()}>
                  {inPackage[id] && <IconWrapper><Icon className="icon-check" /></IconWrapper>}
                </Check>
              ))}
            </Row>
          ))}
        </tbody>
      </Table>
    ))}
  </Container>
);

const mapStateToProps = (state): StateProps => ({
  shortcodes: getShortcodes(state),
  originalnames: getOriginalNames(state),
  packageCompareTable: getPackageContentsTable(state),
});

export default connect<any, any, StateProps, any, any, any>(mapStateToProps)(PackageCompare);
